import * as THREE from "three";
import {
  calculateBounds,
  calculateFurthestFrame,
  fromMM,
  toMM,
} from "./frameUtils";
import { COMPONENT_ALIGNMENT } from "../Constants";
export const DIM_AXES = { X: "x", Y: "y", Z: "z" };

export function makeDimensionable({
  id,
  type,
  position,
  size,
  framePosition,
  frameSize,
  unitBounds,
  visibleAxes = ["x", "y", "z"],
  alignment = 1,
  levels = [1, 1, 1],
  text = "",
  useFullFrame = true,
  ignoreHidden,
  alignments = null,
  suppressLength = false,
}) {
  return {
    id,
    type,
    boundingBox: { position, size },
    frameBoundingBox: {
      position: framePosition ?? position,
      size: frameSize ?? size,
    },
    unitBounds,
    visibleAxes,
    alignment,
    levels,
    text,
    useFullFrame,
    ignoreHidden,
    alignments,
    suppressLength,
  };
}

// export function calculateDimensions(
//   dimensionables,
//   dimSide = 1,
//   offsetHorizontal = 0,
//   offsetVertical = 0,
//   isTotal = false,
//   ignore_hidden = false,
// ) {
//   const results = [];

//   for (const item of dimensionables) {
//     let dimensionSide = dimSide;
//     let ignoreHidden = item.ignoreHidden ?? ignore_hidden;

//     let lengthAlignment = item.alignments
//       ? item.alignments.length == COMPONENT_ALIGNMENT.TOP
//         ? 1
//         : -1
//       : 1;

//     //let overrideHeightDimensionSideX = false;
//     let overrideWidthDimensionSideX = 0;
//     let overrideHeightDimensionSideX = 0;

//     // //override dimension side
//     // if (
//     //   item.dimensionSides !== null &&
//     //   item.dimensionSides !== undefined &&
//     //   false
//     // ) {
//     //   overrideWidthDimensionSideX = item.dimensionSides.width[0] !== 0;
//     //   overrideHeightDimensionSideX = item.dimensionSides.height[0] !== 0;
//     // }

//     if (item.type == "text") {
//       results.push({
//         id: item.id,
//         type: item.type,
//         text: item.text,
//         showLength: true,
//         positions: { length: item.boundingBox.position },
//       });
//       continue;
//     }

//     const { position, size } = item.boundingBox;
//     const { position: framePosition, size: frameSize } = item.frameBoundingBox;
//     const [w, h, d] = size;
//     const [x, y, z] = position;

//     const [fw, fh, fd] = frameSize;
//     const [fx, fy, fz] = framePosition;

//     const unitBounds = item.unitBounds;

//     const showX1 = item.visibleAxes.includes("x1");
//     const showX2 = item.visibleAxes.includes("x2");
//     const showX12 = item.visibleAxes.includes("x");

//     const showY1 = item.visibleAxes.includes("y1");
//     const showY2 = item.visibleAxes.includes("y2");
//     const showY12 = item.visibleAxes.includes("y");

//     const showZ1 = item.visibleAxes.includes("z1");
//     const showZ2 = item.visibleAxes.includes("z2");
//     const showZ12 = item.visibleAxes.includes("z");

//     if (dimensionSide == 0) {
//       if (showY1 || showY2) {
//         dimensionSide = showY2 ? 1 : -1;
//       } else if (showY12) {
//         dimensionSide = 1;
//       }

//       overrideHeightDimensionSideX = showY1 ? -1 : 1;
//       overrideWidthDimensionSideX = showZ1 ? -1 : 1;
//     }

//     const showX =
//       dimSide == 0 ||
//       (showX1 && dimensionSide == -1) ||
//       (showX2 && dimensionSide == 1) ||
//       showX12;
//     const showY =
//       (showY1 && dimensionSide == -1) ||
//       (showY2 && dimensionSide == 1) ||
//       showY12;
//     const showZ =
//       (showZ1 && dimensionSide == -1) ||
//       (showZ2 && dimensionSide == 1) ||
//       showZ12;

//     // const BASE_X = item.useFullFrame
//     //   ? unitBounds[
//     //       overrideHeightDimensionSideX
//     //         ? item.dimensionSides.height[0] == -1
//     //           ? 0
//     //           : 1
//     //         : dimensionSide == 1
//     //           ? 0
//     //           : 1
//     //     ]
//     //   : fx + (fw / 2) * dimensionSide * -1;
//     const BASE_X = item.useFullFrame
//       ? unitBounds[
//           overrideHeightDimensionSideX != 0
//             ? overrideHeightDimensionSideX == -1
//               ? 0
//               : 1
//             : dimensionSide == 1
//               ? 0
//               : 1
//         ]
//       : fx + (fw / 2) * dimensionSide * -1;
//     const BASE_Y = lengthAlignment * framePosition[1] + frameSize[1] / 2; //* lengthAlignment;
//     // const BASE_Z =
//     //   unitBounds[
//     //     overrideWidthDimensionSideX
//     //       ? item.dimensionSides.width[0] == -1
//     //         ? 0
//     //         : 1
//     //       : dimensionSide == 1
//     //         ? 1
//     //         : 0
//     //   ];
//     const BASE_Z =
//       unitBounds[
//         overrideWidthDimensionSideX != 0
//           ? overrideWidthDimensionSideX == -1
//             ? 0
//             : 1
//           : dimensionSide == 1
//             ? 1
//             : 0
//       ];

//     //const lengthPosition = [x, y + h / 2 + offsetV, z + d / 2];
//     const lengthPosition = [
//       x,
//       offsetVertical + BASE_Y + lengthAlignment * item.levels[0] * 0.25,
//       (fd / 2) * dimensionSide * -1,
//     ];
//     // const heightPosition = [
//     //   //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
//     //   offsetHorizontal +
//     //     BASE_X +
//     //     item.levels[1] *
//     //       0.25 *
//     //       (overrideHeightDimensionSideX
//     //         ? item.dimensionSides.height[0]
//     //         : dimensionSide * -1),
//     //   y,
//     //   (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
//     // ];
//     const heightPosition = [
//       //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
//       offsetHorizontal +
//         BASE_X +
//         item.levels[1] *
//           0.25 *
//           (overrideHeightDimensionSideX != 0
//             ? overrideHeightDimensionSideX
//             : dimensionSide * -1),
//       y,
//       (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
//     ];
//     // const widthPosition = [
//     //   BASE_Z +
//     //     item.levels[2] *
//     //       0.25 *
//     //       (overrideWidthDimensionSideX
//     //         ? item.dimensionSides.width[0]
//     //         : dimensionSide),
//     //   0,
//     //   z,
//     // ];
//     const widthPosition = [
//       BASE_Z +
//         item.levels[2] *
//           0.25 *
//           (overrideWidthDimensionSideX != 0
//             ? overrideWidthDimensionSideX
//             : dimensionSide),
//       0,
//       z,
//     ];

//     results.push({
//       id: item.id,
//       type: item.type,
//       length: w,
//       height: h,
//       width: d,
//       lengthMM: Math.round(toMM(w)),
//       heightMM: Math.round(toMM(h)),
//       widthMM: Math.round(toMM(d)),
//       showLength: showX || ignoreHidden,
//       showHeight: showY || ignoreHidden,
//       // showWidth:
//       //   (overrideWidthDimensionSideX &&
//       //     (item.dimensionSides.width[0] == dimensionSide || dimSide == 0)) ||
//       //   (!overrideWidthDimensionSideX && showZ),
//       showWidth: showZ,
//       positions: {
//         length: lengthPosition,
//         height: heightPosition,
//         width: widthPosition,
//       },
//       dimensionYAlignment: item.dimensionYAlignment,
//     });
//   }
//   return results;
// }

export function calculateDimensions(
  dimensionables,
  dimSide = 1,
  offsetHorizontal = 0,
  offsetVertical = 0,
  isTotal = false,
  ignore_hidden = false,
  projection = null,
) {
  const results = [];
  // End elevations (left/right) place every callout against the same envelope
  // edge, so overlapping spans have to be pushed onto separate tiers or they
  // render stacked on top of each other. Tracked per axis across the whole
  // dimensionable list, hence the outer scope.
  const endDimensionSpans = { height: [], width: [] };

  for (const item of dimensionables) {
    let dimensionSide = dimSide;
    let ignoreHidden = item.ignoreHidden ?? ignore_hidden;

    let lengthAlignment = item.alignments
      ? item.alignments.length == COMPONENT_ALIGNMENT.TOP
        ? 1
        : -1
      : 1;

    //let overrideHeightDimensionSideX = false;
    let overrideWidthDimensionSideX = 0;
    let overrideHeightDimensionSideX = 0;

    // //override dimension side
    // if (
    //   item.dimensionSides !== null &&
    //   item.dimensionSides !== undefined &&
    //   false
    // ) {
    //   overrideWidthDimensionSideX = item.dimensionSides.width[0] !== 0;
    //   overrideHeightDimensionSideX = item.dimensionSides.height[0] !== 0;
    // }

    if (item.type == "text") {
      results.push({
        id: item.id,
        type: item.type,
        text: item.text,
        showLength: true,
        positions: { length: item.boundingBox.position },
      });
      continue;
    }

    const { position, size } = item.boundingBox;
    const { position: framePosition, size: frameSize } = item.frameBoundingBox;
    const [w, h, d] = size;
    const [x, y, z] = position;

    const [fw, fh, fd] = frameSize;
    const [fx, fy, fz] = framePosition;

    const unitBounds = item.unitBounds;

    const showX1 = item.visibleAxes.includes("x1");
    const showX2 = item.visibleAxes.includes("x2");
    const showX12 = item.visibleAxes.includes("x");

    const showY1 = item.visibleAxes.includes("y1");
    const showY2 = item.visibleAxes.includes("y2");
    const showY12 = item.visibleAxes.includes("y");

    const showZ1 = item.visibleAxes.includes("z1");
    const showZ2 = item.visibleAxes.includes("z2");
    const showZ12 = item.visibleAxes.includes("z");

    if (dimensionSide == 0) {
      if (showY1 || showY2) {
        dimensionSide = showY2 ? 1 : -1;
      } else if (showY12) {
        dimensionSide = 1;
      }

      overrideHeightDimensionSideX = showY1 ? -1 : 1;
      overrideWidthDimensionSideX = showZ1 ? -1 : 1;
    } else {
      // 3D (non-zero dimSide): an explicit single-sided axis must still pin the
      // height/width line to that physical side, independent of the view-driven
      // dimensionSide. Without this, y1 mapped to the right end (BASE_X uses the
      // plain dimensionSide otherwise), so unit/section heights ignored the
      // external-component side rule in 3D. Only the placement (BASE_X/BASE_Z)
      // is overridden here; visibility (showY/showZ) is left untouched.
      if (showY1) overrideHeightDimensionSideX = -1;
      else if (showY2) overrideHeightDimensionSideX = 1;
      if (showZ1) overrideWidthDimensionSideX = -1;
      else if (showZ2) overrideWidthDimensionSideX = 1;
    }

    // End elevations read height/width in the Y/Z plane only - a length line
    // there would be drawn end-on (zero extent) and just collide with the
    // height/width callouts.
    const isEndProjection = projection === "left" || projection === "right";
    const showX =
      !isEndProjection &&
      (dimSide == 0 ||
        (showX1 && dimensionSide == -1) ||
        (showX2 && dimensionSide == 1) ||
        showX12);
    const showY =
      (showY1 && dimensionSide == -1) ||
      (showY2 && dimensionSide == 1) ||
      showY12;
    const showZ =
      (showZ1 && dimensionSide == -1) ||
      (showZ2 && dimensionSide == 1) ||
      showZ12;

    // const BASE_X = item.useFullFrame
    //   ? unitBounds[
    //       overrideHeightDimensionSideX
    //         ? item.dimensionSides.height[0] == -1
    //           ? 0
    //           : 1
    //         : dimensionSide == 1
    //           ? 0
    //           : 1
    //     ]
    //   : fx + (fw / 2) * dimensionSide * -1;
    const BASE_X = item.useFullFrame
      ? unitBounds[
          overrideHeightDimensionSideX != 0
            ? overrideHeightDimensionSideX == -1
              ? 0
              : 1
            : dimensionSide == 1
              ? 0
              : 1
        ]
      : fx + (fw / 2) * dimensionSide * -1;
    const BASE_Y = lengthAlignment * framePosition[1] + frameSize[1] / 2; //* lengthAlignment;
    // const BASE_Z =
    //   unitBounds[
    //     overrideWidthDimensionSideX
    //       ? item.dimensionSides.width[0] == -1
    //         ? 0
    //         : 1
    //       : dimensionSide == 1
    //         ? 1
    //         : 0
    //   ];
    const BASE_Z =
      unitBounds[
        overrideWidthDimensionSideX != 0
          ? overrideWidthDimensionSideX == -1
            ? 0
            : 1
          : dimensionSide == 1
            ? 1
            : 0
      ];

    //const lengthPosition = [x, y + h / 2 + offsetV, z + d / 2];
    const lengthPosition = [
      x,
      offsetVertical + BASE_Y + lengthAlignment * item.levels[0] * 0.25,
      (fd / 2) * dimensionSide * -1,
    ];
    // const heightPosition = [
    //   //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
    //   offsetHorizontal +
    //     BASE_X +
    //     item.levels[1] *
    //       0.25 *
    //       (overrideHeightDimensionSideX
    //         ? item.dimensionSides.height[0]
    //         : dimensionSide * -1),
    //   y,
    //   (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
    // ];

    const heightDimensionsSide =  overrideHeightDimensionSideX != 0
            ? overrideHeightDimensionSideX
            : dimensionSide * -1;

    const heightScale = 
      item.levels[1] == 1 ? 0.4 : item.levels[1] == 2 ? 0.45 : 0.55;
    const heightPosition = [
      //offsetHorizontal + BASE_X + item.levels[1] * 0.25 * dimensionSide * -1,
      //  offsetHorizontal + BASE_X + item.levels[1] * 0.25 * (overrideHeightDimensionSideX != 0 ? overrideHeightDimensionSideX : dimensionSide * -1),
      offsetHorizontal +
        BASE_X +
        item.levels[1] *
          heightScale * heightDimensionsSide,
      y,
      (fd / 2) * dimensionSide * (ignoreHidden ? 1 : -1),
    ];
    // const widthPosition = [
    //   BASE_Z +
    //     item.levels[2] *
    //       0.25 *
    //       (overrideWidthDimensionSideX
    //         ? item.dimensionSides.width[0]
    //         : dimensionSide),
    //   0,
    //   z,
    // ];

    const widthScale =
      item.levels[2] == 1 ? 0.4 : item.levels[2] == 2 ? 0.45 : 0.55;

    const widthPosition = [
      BASE_Z +
        item.levels[2] *
          widthScale *
          (overrideWidthDimensionSideX != 0
            ? overrideWidthDimensionSideX
            : dimensionSide),
      0,
      z,
    ];

    if (isEndProjection) {
      // Allocate the first tier on this axis whose already-reserved spans do
      // not overlap this one, so coincident callouts stack outward instead of
      // rendering on top of each other.
      const reserveTier = (axis, center, size) => {
        let tier = 0;
        while (
          endDimensionSpans[axis].some(
            (span) =>
              span.tier === tier &&
              center - size / 2 < span.center + span.size / 2 &&
              center + size / 2 > span.center - span.size / 2,
          )
        ) {
          tier += 1;
        }
        endDimensionSpans[axis].push({ center, size, tier });
        return tier;
      };

      const tierOffset = heightScale;
      const widthTier = reserveTier("width", z, d);
      const heightTier = reserveTier("height", y, h);

      // End elevations: anchor callouts to the envelope edges, offset outward.
      // Width (horizontal in the drawing) sits above the top (max Y).
      widthPosition[1] = y + h / 2 + tierOffset * (1 + widthTier);
      // Height (vertical in the drawing) sits outside the near side: left end
      // view → right edge; right end view → left edge.
      heightPosition[2] =
        projection === "left"
          ? z + d / 2 + tierOffset * (1 + heightTier)
          : z - d / 2 - tierOffset * (1 + heightTier);
    }

    results.push({
      id: item.id,
      type: item.type,
      length: w,
      height: h,
      width: d,
      lengthMM: Math.round(toMM(w)),
      heightMM: Math.round(toMM(h)),
      widthMM: Math.round(toMM(d)),
      showLength: !item.suppressLength && (showX || ignoreHidden),
      showHeight: showY || ignoreHidden,
      // showWidth:
      //   (overrideWidthDimensionSideX &&
      //     (item.dimensionSides.width[0] == dimensionSide || dimSide == 0)) ||
      //   (!overrideWidthDimensionSideX && showZ),
      showWidth: showZ,
      positions: {
        length: lengthPosition,
        height: heightPosition,
        width: widthPosition,
      },
      dimensionYAlignment: item.dimensionYAlignment,
      dimensionSide,
      // Exposed so the SVG emitter can preserve tier spacing when it has to
      // reposition a line (see the top-projection clamp in createSVGDimensions).
      levels: item.levels,
    });
  }
  return results;
}

export function collectDimensionables(
  frames,
  allFrames,
  frameThickness,
  view,
  baseframeHeight,
  isTotal,
  sectionViews,
  dimenionsionSide = 0,
  endElevation = false,
) {
  const items = [];
  const CROSS_SECTION_EPS = 1e-4;

  let x1 = calculateFurthestFrame(allFrames, -1, "length", frameThickness);
  let x2 = calculateFurthestFrame(allFrames, 1, "length", frameThickness);

  let isSections = frames.length > 1;
  let frame = frames[0];
  let frame2 = isSections ? frames[frames.length - 1] : frames[0];

  const hasLeftConnection =
    frame.connections?.filter(
      (c) => c.attachedTo != null && c.side == COMPONENT_ALIGNMENT.LEFT,
    ).length > 0;
  const hasRightConnection =
    frame2.connections?.filter(
      (c) => c.attachedTo != null && c.side == COMPONENT_ALIGNMENT.RIGHT,
    ).length > 0;
  const bounds = getFrameBounds(frames, frameThickness, baseframeHeight);

  // Unit cross-section (height/width across all frames). Used to drop a single
  // frame's height/width callout when it equals the unit's, so the per-frame
  // pass doesn't duplicate the height/width the unit-total pass already draws
  // (e.g. an exterior ESP emitting 1250 on top of the unit's 2550 at the same
  // left-hand position). getFrameBounds ignores the third arg, so both bounds
  // are measured on the same basis and stay comparable.
  const unitBounds3D = getFrameBounds(allFrames, frameThickness);
  const matchesUnitHeight =
    Math.abs(bounds.size[1] - unitBounds3D.size[1]) < CROSS_SECTION_EPS;
  const matchesUnitWidth =
    Math.abs(bounds.size[2] - unitBounds3D.size[2]) < CROSS_SECTION_EPS;

  if (isSections) {
    // Body height excluding the base frame, drawn one lane inside the overall
    // unit height so both are readable (e.g. 1100 body vs 1200 including base).
    // 2D only: the 3D view already shows the unit height on its own tier, and
    // emitting the body height there too rendered a second identical 1100.
    const bodyHeightBounds =
      view === "2d" && isTotal && baseframeHeight
        ? { pos: [...bounds.pos], size: [...bounds.size] }
        : null;

    //unit height
    if (isTotal && baseframeHeight) {
      bounds.size[1] += baseframeHeight;
      bounds.pos[1] -= baseframeHeight / 2;
    }

    if (bodyHeightBounds) {
      const sectionView = sectionViews && sectionViews[view];
      const baseLevels = sectionView ? sectionView.levels : [1, 2, 1];
      items.push(
        makeDimensionable({
          id: `${frame.id}-body-height`,
          // Height only - length/width are already covered by the overall unit
          // dimensionable pushed below.
          //
          // Filtering visibleAxes to "y" is NOT enough to suppress the length:
          // calculateDimensions sets showX unconditionally when dimSide == 0
          // (`showX = dimSide == 0 || ...`), which is what the 2D path passes.
          // Without suppressLength this drew a second full unit length on its
          // own lane, above the drawing.
          suppressLength: true,
          visibleAxes: (sectionView ? sectionView.visibleAxes : ["x"]).filter(
            (a) => a.startsWith("y"),
          ),
          levels: [
            baseLevels[0],
            Math.max(1, (baseLevels[1] ?? 2) - 1),
            baseLevels[2],
          ],
          type: "frame",
          position: bodyHeightBounds.pos,
          size: bodyHeightBounds.size,
          unitBounds: [x1, x2],
        }),
      );
    }

    items.push(
      makeDimensionable({
        id: frame.id,
        visibleAxes:
          sectionViews && sectionViews[view]
            ? sectionViews[view].visibleAxes
            : ["x"],
        levels:
          sectionViews && sectionViews[view]
            ? sectionViews[view].levels
            : [1, 2, 1],
        alignments:
          sectionViews && sectionViews[view] && sectionViews[view].alignments
            ? sectionViews[view].alignments
            : null,
        // dimensionSides:
        //   sectionViews &&
        //   sectionViews[view] &&
        //   sectionViews[view].dimensionSides
        //     ? sectionViews[view].dimensionSides
        //     : null,
        // hasLeftConnection && hasRightConnection
        //   ? ["x"]
        //   : [
        //       "x",
        //       hasLeftConnection ? "y1" : hasRightConnection ? "y2" : "y",
        //       hasLeftConnection ? "z1" : hasRightConnection ? "z2" : "z",
        //     ],
        type: "frame",
        position: bounds.pos,
        size: bounds.size,
        unitBounds: [x1, x2],
      }),
    );

    return items;
  } else if (endElevation || !frames[0].isExterior) {
    items.push(
      makeDimensionable({
        id: frame.id,
        // End elevations always read height/width in the Y/Z plane, so the
        // side-specific 2D axes (y2/z2, x, ...) used by the top/side views do
        // not apply - a z2-only item would render no line here.
        visibleAxes: endElevation
          ? ["y", "z"]
          : frames[0].dimension
          ? frames[0].dimension.visibleAxes
          : hasLeftConnection && hasRightConnection
            ? ["x"]
            : [
                "x",
                // Drop the height axis when this frame spans the full unit
                // height (the unit-total pass already draws it) to avoid a
                // duplicate stacked at the same position.
                ...(matchesUnitHeight
                  ? []
                  : [
                      dimenionsionSide == 0
                        ? hasLeftConnection
                          ? "y2"
                          : hasRightConnection
                            ? "y1"
                            : "y"
                        : hasLeftConnection
                          ? "y1"
                          : hasRightConnection
                            ? "y2"
                            : "y",
                    ]),
                // Likewise drop the width axis when it equals the unit width.
                ...(matchesUnitWidth
                  ? []
                  : [
                      hasLeftConnection
                        ? "z2"
                        : hasRightConnection
                          ? "z1"
                          : "z",
                    ]),
              ],
        type: "frame",
        position: bounds.pos,
        size: bounds.size,
        unitBounds: [x1, x2],
      }),
    );
  }
  // NOTE: exterior frames (external ESP/fan) intentionally get no frame-level
  // dimensionable here. Their length is already covered by their own
  // innerComponents (e.g. the ESP body plus its cone distance), so emitting the
  // frame length as well would draw a redundant third value that collides with
  // the component dimensions beside it.

  for (const frame of frames) {
    const bounds = getFrameBounds([frame], frameThickness);
    if (frame.innerComponents) {
      for (const comp of frame.innerComponents) {
        const pos = comp.boundingBox?.position ?? [0, 0, 0];
        const size = comp.boundingBox?.size ?? [1, 1, 1];
        const views = comp.views;
        items.push(
          makeDimensionable({
            id: comp.id,
            type: comp.type,
            position: [
              bounds.pos[0] + pos[0],
              bounds.pos[1] + pos[1],
              bounds.pos[2] + pos[2],
            ],
            size,
            framePosition: bounds.pos,
            frameSize: bounds.size,
            unitBounds: [x1, x2],
            visibleAxes: views && views[view] ? views[view].visibleAxes : [],
            levels:
              views && views[view] && views[view].levels?.length
                ? views[view].levels
                : [1, 1, 1],
            alignments:
              views && views[view] && views[view].alignments
                ? views[view].alignments
                : null,
            text: comp.text,
            useFullFrame: comp.useFullFrame,
            ignoreHidden: comp.ignoreHidden,
          }),
        );
      }
    }
  }

  if (endElevation) {
    const frameDimension = items.find((item) => item.id === frame.id);

    const crossSectionComponents = items.filter(
      (item) =>
        item.id !== frame.id &&
        item.boundingBox.size[1] > 0 &&
        item.boundingBox.size[2] > 0 &&
        (item.visibleAxes.includes("y") ||
          item.visibleAxes.includes("y1") ||
          item.visibleAxes.includes("y2") ||
          item.visibleAxes.includes("z") ||
          item.visibleAxes.includes("z1") ||
          item.visibleAxes.includes("z2")),
    );

    const frameMinY = bounds.pos[1] - bounds.size[1] / 2;
    const frameMaxY = bounds.pos[1] + bounds.size[1] / 2;
    const frameMinZ = bounds.pos[2] - bounds.size[2] / 2;
    const frameMaxZ = bounds.pos[2] + bounds.size[2] / 2;
    const exteriorComponents = crossSectionComponents.filter((item) => {
      const [, y, z] = item.boundingBox.position;
      const [, h, d] = item.boundingBox.size;
      return (
        y - h / 2 < frameMinY - CROSS_SECTION_EPS ||
        y + h / 2 > frameMaxY + CROSS_SECTION_EPS ||
        z - d / 2 < frameMinZ - CROSS_SECTION_EPS ||
        z + d / 2 > frameMaxZ + CROSS_SECTION_EPS
      );
    });

    // An end component usually occupies its frame, so its frame envelope is the
    // only manufacturing cross-section to call out. When an attached component
    // extends beyond that frame (ESP box / accessories), use those component
    // envelopes instead. Axes are remapped to ["y", "z"] for the same reason as
    // the frame dimensionable above.
    return exteriorComponents.length > 0
      ? exteriorComponents.map((item) => ({
          ...item,
          visibleAxes: ["y", "z"],
        }))
      : frameDimension
        ? [frameDimension]
        : [];
  }

  return items;
}

function getFrameBounds(frames, frameThickness) {
  const _boxPos = new THREE.Vector3();
  const _boxSize = new THREE.Vector3();
  calculateBounds(frames, _boxPos, _boxSize, frameThickness);
  return {
    pos: [_boxPos.x, _boxPos.y, _boxPos.z],
    size: [_boxSize.x, _boxSize.y, _boxSize.z],
  };
}
